// PROSPECT'HEURE — Multilingual dictionary
// Keys stay in English/snake_case for clarity; values are per-language strings.
// Fallback order: selected -> fr (default).

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
];

export const RTL_LANGS = new Set(["ar"]);

/* eslint-disable no-irregular-whitespace */
export const TRANSLATIONS = {
  // ------------------- HEADER -------------------
  "nav.guide": {
    fr: "Le guide", en: "The guide", es: "La guía", pt: "O guia",
    de: "Der Leitfaden", it: "La guida", ar: "الدليل", zh: "指南",
  },
  "nav.conferences": {
    fr: "Conférences", en: "Conferences", es: "Conferencias", pt: "Conferências",
    de: "Konferenzen", it: "Conferenze", ar: "المؤتمرات", zh: "会议",
  },
  "nav.training": {
    fr: "L'entraînement", en: "The training", es: "El entrenamiento", pt: "O treinamento",
    de: "Das Training", it: "L'allenamento", ar: "التدريب", zh: "培训",
  },
  "nav.coach": {
    fr: "L'entraîneur", en: "The coach", es: "El entrenador", pt: "O treinador",
    de: "Der Trainer", it: "L'allenatore", ar: "المدرب", zh: "教练",
  },
  "cta.login": {
    fr: "Se connecter", en: "Sign in", es: "Iniciar sesión", pt: "Entrar",
    de: "Anmelden", it: "Accedi", ar: "تسجيل الدخول", zh: "登录",
  },
  "cta.start": {
    fr: "Commencer l'entraînement", en: "Start the training", es: "Comenzar el entrenamiento",
    pt: "Iniciar o treinamento", de: "Training beginnen", it: "Iniziare l'allenamento",
    ar: "ابدأ التدريب", zh: "开始培训",
  },
  "cta.myspace": {
    fr: "Mon espace", en: "My area", es: "Mi espacio", pt: "Meu espaço",
    de: "Mein Bereich", it: "Il mio spazio", ar: "مساحتي", zh: "我的空间",
  },
  "cta.logout": {
    fr: "Déconnexion", en: "Log out", es: "Cerrar sesión", pt: "Sair",
    de: "Abmelden", it: "Disconnetti", ar: "تسجيل الخروج", zh: "退出",
  },
  "header.tagline": {
    fr: "L'heure des prospect·e·s", en: "The hour of prospects", es: "La hora de los prospectos",
    pt: "A hora dos prospects", de: "Die Stunde der Interessenten", it: "L'ora dei prospect",
    ar: "ساعة المحتملين", zh: "客户开发时刻",
  },

  // ------------------- HERO -------------------
  "hero.kicker": {
    fr: "Entraînement à l'excellence de Profitheque Canada",
    en: "Excellence Training by Profitheque Canada",
    es: "Entrenamiento a la excelencia de Profitheque Canada",
    pt: "Treinamento à excelência da Profitheque Canada",
    de: "Exzellenz-Training von Profitheque Canada",
    it: "Allenamento all'eccellenza di Profitheque Canada",
    ar: "تدريب على التميّز من بروفيتيك كندا",
    zh: "Profitheque 加拿大卓越训练",
  },
  "hero.welcome": {
    fr: "Bienvenue !", en: "Welcome!", es: "¡Bienvenido!", pt: "Bem-vindo!",
    de: "Willkommen!", it: "Benvenuto!", ar: "أهلاً بك!", zh: "欢迎!",
  },
  "hero.title_1": {
    fr: "Il est temps de prospecter", en: "It's time to prospect",
    es: "Es hora de prospectar", pt: "É hora de prospectar",
    de: "Es ist Zeit zu akquirieren", it: "È tempo di fare prospezione",
    ar: "حان وقت التنقيب عن العملاء", zh: "开发客户的时刻到了",
  },
  "hero.title_2": {
    fr: "sans se faire rejeter", en: "without being rejected",
    es: "sin ser rechazado", pt: "sem ser rejeitado",
    de: "ohne abgelehnt zu werden", it: "senza essere rifiutati",
    ar: "دون رفض", zh: "而不被拒绝",
  },
  "hero.title_3": {
    fr: "avec Prospect'Heure.", en: "with Prospect'Heure.",
    es: "con Prospect'Heure.", pt: "com Prospect'Heure.",
    de: "mit Prospect'Heure.", it: "con Prospect'Heure.",
    ar: "مع Prospect'Heure.", zh: "选择 Prospect'Heure。",
  },
  "hero.subtitle": {
    fr: "L'heure des prospects a véritablement sonné.",
    en: "The prospects' hour has truly struck.",
    es: "La hora de los prospectos ha sonado de verdad.",
    pt: "A hora dos prospects realmente chegou.",
    de: "Die Stunde der Interessenten hat wirklich geschlagen.",
    it: "L'ora dei prospect è davvero suonata.",
    ar: "لقد حانت ساعة المحتملين حقًا.",
    zh: "客户开发的时刻真正到来了。",
  },
  "hero.description": {
    fr: "Le guide pratique et les entraînements de Profitheque Canada, conçus par Roméo Chouaké, Entraîneur d'Excellence, pour transformer la prospection en une compétence naturelle — et bâtir une activité durable.",
    en: "The practical guide and training programs by Profitheque Canada, designed by Roméo Chouaké, Excellence Trainer, to turn prospecting into a natural skill — and build a lasting business.",
    es: "La guía práctica y los entrenamientos de Profitheque Canada, diseñados por Roméo Chouaké, Entrenador de Excelencia, para convertir la prospección en una habilidad natural y construir un negocio duradero.",
    pt: "O guia prático e os treinamentos da Profitheque Canada, criados por Roméo Chouaké, Treinador de Excelência, para transformar a prospecção em uma habilidade natural — e construir um negócio duradouro.",
    de: "Der Praxis-Leitfaden und die Trainings von Profitheque Canada, entwickelt von Roméo Chouaké, Exzellenz-Trainer, um Akquise in eine natürliche Fähigkeit zu verwandeln — und ein nachhaltiges Geschäft aufzubauen.",
    it: "La guida pratica e gli allenamenti di Profitheque Canada, creati da Roméo Chouaké, Allenatore d'Eccellenza, per trasformare la prospezione in una competenza naturale e costruire un'attività duratura.",
    ar: "الدليل التطبيقي وبرامج تدريب Profitheque Canada، من تصميم روميو شواكي، مدرّب التميّز، لتحويل التنقيب عن العملاء إلى مهارة طبيعية وبناء نشاط مستدام.",
    zh: "由卓越训练师 Roméo Chouaké 设计的 Profitheque 加拿大实践指南与训练体系,让客户开发成为你的自然能力,构建持久的事业。",
  },
  "hero.discover": {
    fr: "Découvrir le guide", en: "Discover the guide", es: "Descubrir la guía",
    pt: "Descobrir o guia", de: "Den Leitfaden entdecken", it: "Scoprire la guida",
    ar: "اكتشف الدليل", zh: "探索指南",
  },
  "hero.stat_years": {
    fr: "années d'expertise", en: "years of expertise", es: "años de experiencia",
    pt: "anos de experiência", de: "Jahre Erfahrung", it: "anni di esperienza",
    ar: "سنوات من الخبرة", zh: "年的专业经验",
  },
  "hero.stat_people": {
    fr: "personnes accompagnées", en: "people trained", es: "personas formadas",
    pt: "pessoas acompanhadas", de: "betreute Personen", it: "persone formate",
    ar: "شخص تم تدريبهم", zh: "位学员",
  },
  "hero.stat_satisfaction": {
    fr: "satisfaction moyenne", en: "average satisfaction", es: "satisfacción media",
    pt: "satisfação média", de: "durchschnittliche Zufriedenheit", it: "soddisfazione media",
    ar: "متوسّط الرضا", zh: "平均满意度",
  },

  // ------------------- BOOK / GUIDE SECTION -------------------
  "book.kicker": {
    fr: "Le guide pratique des entraînements de Profitheque Canada",
    en: "The practical guide to Profitheque Canada training",
    es: "La guía práctica de los entrenamientos de Profitheque Canada",
    pt: "O guia prático dos treinamentos da Profitheque Canada",
    de: "Der Praxis-Leitfaden zu den Trainings von Profitheque Canada",
    it: "La guida pratica agli allenamenti di Profitheque Canada",
    ar: "الدليل التطبيقي لتدريبات Profitheque Canada",
    zh: "Profitheque 加拿大训练实践指南",
  },
  "book.title_1": { fr: "PROSPECTER", en: "PROSPECT", es: "PROSPECTAR", pt: "PROSPECTAR",
    de: "AKQUIRIEREN", it: "PROSPEZIONE", ar: "التنقيب", zh: "开发客户" },
  "book.title_2": { fr: "sans se faire rejeter", en: "without being rejected",
    es: "sin ser rechazado", pt: "sem ser rejeitado", de: "ohne abgelehnt zu werden",
    it: "senza essere rifiutati", ar: "دون رفض", zh: "而不被拒绝" },
  "book.description": {
    fr: "Le guide pratique et les entraînements de Profitheque Canada, fruit de plus de 25 années d'expérience terrain. Chaque chapitre vous donne un outil concret pour prospecter avec calme, posture et efficacité.",
    en: "The practical guide and training programs by Profitheque Canada — 25+ years of field experience. Every chapter gives you a concrete tool to prospect with calm, posture and efficiency.",
    es: "La guía práctica y los entrenamientos de Profitheque Canada — más de 25 años de experiencia. Cada capítulo te ofrece una herramienta concreta para prospectar con calma, postura y eficacia.",
    pt: "O guia prático e os treinamentos da Profitheque Canada — mais de 25 anos de experiência de campo. Cada capítulo dá uma ferramenta concreta para prospectar com calma, postura e eficácia.",
    de: "Der Praxis-Leitfaden und die Trainings von Profitheque Canada — 25+ Jahre Praxiserfahrung. Jedes Kapitel liefert ein konkretes Werkzeug für ruhige, souveräne und effiziente Akquise.",
    it: "La guida pratica e gli allenamenti di Profitheque Canada — oltre 25 anni di esperienza sul campo. Ogni capitolo ti offre uno strumento concreto per la prospezione con calma, postura ed efficacia.",
    ar: "الدليل التطبيقي وبرامج Profitheque Canada — أكثر من 25 عامًا من الخبرة الميدانية. كل فصل يمنحك أداة ملموسة للتنقيب بهدوء وثبات وفعّالية.",
    zh: "Profitheque 加拿大实践指南与训练体系 — 25+ 年现场经验的结晶。每一章都提供一件具体工具,助你从容、自信、高效地开发客户。",
  },
  "book.format": { fr: "Format", en: "Format", es: "Formato", pt: "Formato",
    de: "Format", it: "Formato", ar: "الصيغة", zh: "形式" },
  "book.format_value": {
    fr: "Guide + Entraînements inclus", en: "Guide + Training included",
    es: "Guía + Entrenamientos incluidos", pt: "Guia + Treinamentos incluídos",
    de: "Leitfaden + Training inklusive", it: "Guida + Allenamenti inclusi",
    ar: "الدليل + التدريبات مضمّنان", zh: "指南 + 训练一起",
  },
  "book.edition": { fr: "Édition officielle", en: "Official edition", es: "Edición oficial",
    pt: "Edição oficial", de: "Offizielle Ausgabe", it: "Edizione ufficiale",
    ar: "الإصدار الرسمي", zh: "官方版本" },
  "book.subtitle": {
    fr: "Déverrouiller le jeu des objections",
    en: "Unlocking the game of objections",
    es: "Desbloquear el juego de las objeciones",
    pt: "Desbloquear o jogo das objeções",
    de: "Das Spiel der Einwände entsperren",
    it: "Sbloccare il gioco delle obiezioni",
    ar: "فكّ لُغز الاعتراضات",
    zh: "解锁异议之局",
  },
  "book.benefits.0": { fr: "Vaincre définitivement la peur du rejet", en: "Overcome the fear of rejection for good",
    es: "Vencer definitivamente el miedo al rechazo", pt: "Vencer definitivamente o medo da rejeição",
    de: "Angst vor Ablehnung endgültig überwinden", it: "Vincere definitivamente la paura del rifiuto",
    ar: "التغلّب نهائياً على الخوف من الرفض", zh: "彻底战胜被拒绝的恐惧" },
  "book.benefits.1": { fr: "Développer une confiance en soi inébranlable", en: "Build unshakable self-confidence",
    es: "Desarrollar una confianza inquebrantable", pt: "Desenvolver uma autoconfiança inabalável",
    de: "Unerschütterliches Selbstvertrauen entwickeln", it: "Sviluppare una fiducia in sé incrollabile",
    ar: "بناء ثقة بالنفس راسخة", zh: "培养坚不可摧的自信" },
  "book.benefits.2": { fr: "Maîtriser les techniques modernes de prospection", en: "Master modern prospecting techniques",
    es: "Dominar las técnicas modernas de prospección", pt: "Dominar as técnicas modernas de prospecção",
    de: "Moderne Akquise-Techniken meistern", it: "Padroneggiare le tecniche moderne di prospezione",
    ar: "إتقان تقنيات التنقيب الحديثة", zh: "掌握现代客户开发技巧" },
  "book.benefits.3": { fr: "Convertir davantage de prospects en clients", en: "Convert more prospects into customers",
    es: "Convertir más prospectos en clientes", pt: "Converter mais prospects em clientes",
    de: "Mehr Interessenten in Kunden verwandeln", it: "Convertire più prospect in clienti",
    ar: "تحويل عدد أكبر من المحتملين إلى عملاء", zh: "把更多潜客变成客户" },
  "book.benefits.4": { fr: "Fidéliser durablement et multiplier les recommandations", en: "Retain customers and multiply referrals",
    es: "Fidelizar y multiplicar las recomendaciones", pt: "Fidelizar e multiplicar as recomendações",
    de: "Kunden binden und Empfehlungen vervielfachen", it: "Fidelizzare e moltiplicare le raccomandazioni",
    ar: "تعزيز الولاء ومضاعفة التوصيات", zh: "建立忠诚度并倍增转介绍" },
  "book.benefits.5": { fr: "Construire une activité stable et rentable", en: "Build a stable, profitable business",
    es: "Construir una actividad estable y rentable", pt: "Construir uma atividade estável e lucrativa",
    de: "Ein stabiles, profitables Geschäft aufbauen", it: "Costruire un'attività stabile e redditizia",
    ar: "بناء نشاط مستقرّ ومربح", zh: "打造稳定、盈利的事业" },

  // ------------------- FOOTER -------------------
  "footer.baseline": {
    fr: "La plateforme internationale pour prospecter sans se faire rejeter — conçue par Roméo Chouaké, Entraîneur d'Excellence.",
    en: "The international platform to prospect without being rejected — designed by Roméo Chouaké, Excellence Trainer.",
    es: "La plataforma internacional para prospectar sin ser rechazado — diseñada por Roméo Chouaké, Entrenador de Excelencia.",
    pt: "A plataforma internacional para prospectar sem ser rejeitado — criada por Roméo Chouaké, Treinador de Excelência.",
    de: "Die internationale Plattform, um akquirieren ohne abgelehnt zu werden — von Roméo Chouaké, Exzellenz-Trainer.",
    it: "La piattaforma internazionale per fare prospezione senza essere rifiutati — creata da Roméo Chouaké, Allenatore d'Eccellenza.",
    ar: "المنصّة الدولية للتنقيب دون رفض — من تصميم روميو شواكي، مدرّب التميّز.",
    zh: "国际化的客户开发平台 — 由卓越训练师 Roméo Chouaké 打造。",
  },
  "footer.contact": { fr: "Contact", en: "Contact", es: "Contacto", pt: "Contato",
    de: "Kontakt", it: "Contatti", ar: "تواصل", zh: "联系" },
  "footer.support_hours": { fr: "Support 7j/7", en: "Support 7/7", es: "Soporte 7/7",
    pt: "Suporte 7/7", de: "Support 7/7", it: "Supporto 7/7", ar: "دعم على مدار الأسبوع", zh: "全天候客服" },
  "footer.navigation": { fr: "Navigation", en: "Navigation", es: "Navegación", pt: "Navegação",
    de: "Navigation", it: "Navigazione", ar: "التنقّل", zh: "导航" },
  "footer.rights": { fr: "Tous droits réservés", en: "All rights reserved",
    es: "Todos los derechos reservados", pt: "Todos os direitos reservados",
    de: "Alle Rechte vorbehalten", it: "Tutti i diritti riservati",
    ar: "جميع الحقوق محفوظة", zh: "版权所有" },
  "footer.powered": { fr: "Propulsé par", en: "Powered by", es: "Impulsado por",
    pt: "Desenvolvido por", de: "Bereitgestellt von", it: "Realizzato da",
    ar: "مُشغَّل بواسطة", zh: "技术支持" },

  // ------------------- LANGUAGE SWITCHER -------------------
  "lang.choose": {
    fr: "Choisir la langue", en: "Choose language", es: "Elegir idioma",
    pt: "Escolher idioma", de: "Sprache wählen", it: "Scegli la lingua",
    ar: "اختر اللغة", zh: "选择语言",
  },
};

export function t(key, lang) {
  const entry = TRANSLATIONS[key];
  if (!entry) return key;
  return entry[lang] || entry.fr || key;
}
